import React from "react";
import AgentResponsiveComp from "../../common/components/agentresponsive/AgentResponsiveComp";
import Sidebar from "../../common/components/Sidebar/sidebar";

const AgentResponsiveScreen = () => {
  return (
    <>
      <section>
        <div className="container-fluid">
          <div className="row p-0">
            <div className="col-lg-2 p-0 m-0">
              <Sidebar />
            </div>
            <div className="col-lg-10 p-0 m-0">
              <div className="row">
                <div className="viewUserMainContainer p-0">
                  <AgentResponsiveComp />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AgentResponsiveScreen;
